import { phoneMask } from '@/constants'

export const debounce = (fn, ms) => {
  let timeout
  return function () {
    const fnCall = () => { fn.apply(this, arguments) }
    clearTimeout(timeout)
    timeout = setTimeout(fnCall, ms)
  }
}

export const parsePhone = (phone) => {
  const chars = '1234567890'.split('')
  return phone
    .split('')
    .map(i => chars.includes(i) ? i : null)
    .filter(i => !!i)
    .join('')
    .slice(1)
}

export const parseToPhone = (phone) => {
  const chars = phone.split('')
  const arr = phoneMask.split('')

  let index = -1
  return arr.map(item => {
    if (item === '#') {
      index++
      return chars[index]
    }

    return item
  }).join('')
}
